/* lua.js generated code 0.3.0 */

require("clover/animation/ui/CommonAnimation")
let MarkRewardPanel = xClass("MarkRewardPanel", BasePanel, cc.Layer)
MarkRewardPanel.prototype.ctor = function (info, finishCallback, lockTable) {
    let self = this
    cc.Layer.prototype.ctor.call(self)
    self.lockTable = lockTable
    self.finishCallback = finishCallback
    self.nodeExist = true
    self.init(info)
}
MarkRewardPanel.prototype.init = function (info) {
    let self = this
    BasePanel.prototype.init.call(self)
    self.setContentSize(cc.size(cc.Director.getInstance().getVisibleSize()))
    self.setScale(self.getReferenceScale())
    self.center()
    let vSize = cc.Director.getInstance().getVisibleSize()
    let mask = UIButton.create(cc.LayerColor.create(), true)
    mask.setContentSize(cc.size(vSize.width / self.getScale(), vSize.height / self.getScale()))
    mask.setPosition(cc.p(-self.getPositionX() / self.getScale(), -self.getPositionY() / self.getScale()))
    mask.setOpacity(0)
    self.addChild(mask, 100)
    let rewards = info.lastMarkRewards || (info.markRef[info.markNum] || table()).rewards || table()
    let countPerRow = 4
    if ($len(rewards) >= 5 && $len(rewards) <= 6) {
        countPerRow = 3
    }
    let margin = 30
    let posBase = cc.p(0, 0)
    let lineCount = Math.ceil($len(rewards) / countPerRow)
    let totalHeight = lineCount * 100 + (lineCount - 1) * margin
    let [sprites, numTexts] = [table(), table()]
    for (let i = 1, v = rewards[1]; v; i++, v = rewards[i]) {
        let sprite = UIItemBuilder.createPropIcon(v.itemId)
        sprite.setScale(105 / sprite.getContentSize().width)
        sprite.setVisible(false)
        let lineCount = Math.min($len(rewards) - Math.floor((i - 1) / countPerRow) * countPerRow, countPerRow)
        let lineWidth = lineCount * sprite.getContentSize().width * sprite.getScale() + (lineCount - 1) * margin
        let idxInLine = (i - 1) % countPerRow + 1
        let lineIdx = Math.floor((i - 1) / countPerRow) + 1
        let text = ccui.TextBMFont.create("x" + tostring(v.num), "font/berlinsansfb_30_bluestroke.fnt")
        text.getVirtualRenderer().setAdditionalKerning(-6)
        text.setName("num")
        text.setScale(sprite.getContentSize().height / 2 / text.getContentSize().height * 4 / 5)
        text.setAnchorPoint(cc.p(0.5, 1))
        let size = sprite.getContentSize()
        text.setPosition(cc.p(size.width, size.height / 2))
        sprite.addChild(text, 10)
        sprite.setPosition(cc.p(posBase.x - lineWidth / 2 + (idxInLine - 1) * margin + (idxInLine - 0.5) * sprite.getContentSize().width * sprite.getScale(), posBase.y + totalHeight / 2 - (lineIdx - 1) * margin - (lineIdx - 0.5) * sprite.getContentSize().height * sprite.getScale()))
        self.addChild(sprite, 120)
        sprite.itemId = v.itemId
        sprite.num = v.num
        table.insert(sprites, sprite)
    }
    let charTable = table()
    let unicode_split_reg = /(?=(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/
    let arr = getText("mark.panel.reward.title").split(unicode_split_reg)
    for(let index in arr){
        let xchar = arr[index]
        if (xchar == null) break
        table.insert(charTable, xchar)
    }
    let [spriteTable, totalWidth] = [table(), 0]
    for (let i = 1, v = charTable[1]; v; i++, v = charTable[i]) {
        let text = cc.LabelBMFont.create(v, "font/zzgftongxin_70_greenstroke.fnt")
        text.setColor(cc.c3b(255, 242, 130))
        totalWidth = totalWidth + text.getContentSize().width
        self.addChild(text, 110)
        table.insert(spriteTable, text)
    }
    let widthAdd = 0
    for (let i = 1, v = spriteTable[1]; v; i++, v = spriteTable[i]) {
        v.setPosition(-totalWidth / 2 + widthAdd + v.getContentSize().width / 2, totalHeight / 2 + 100)
        widthAdd = widthAdd + v.getContentSize().width
        v.setVisible(false)
    }
    let button = UIGLabelButton.create(cc.CSLoader.createNode("cocos/mark_panel_bottom_btn_green_start.csb"))
    button.setString(getText("mark.panel.reward.btn"))
    button.setCascadeOpacityEnabled(true)
    button.setVisible(false)
    button.setPosition(cc.p(0, -totalHeight / 2 - 150))
    self.addChild(button, 130)
    for (let i = 1, v = spriteTable[1]; v; i++, v = spriteTable[i]) {
        let recPos = cc.p(v.getPosition())
        let recScale = v.getScale()
        v.setPosition(cc.p(recPos.x * 0.5, recPos.y - 190))
        v.setScale(0.5)
        v.runAction(cc.Sequence.create(cc.DelayTime.create((i - 1) * 0.03), cc.ToggleVisibility.create(), cc.EaseSineOut.create(cc.Spawn.create(cc.MoveTo.create(0.23, cc.p(recPos.x, recPos.y)), cc.ScaleTo.create(0.23, recScale))), cc.CallFunc.create(function () {
            if (i === 1) {
                mask.runAction(cc.FadeTo.create(0.26, 165))
                let [numTable, glowTable] = [table(), table()]
                let counter = $len(sprites) + 1
                function onAnimFinish() {
                    counter = counter - 1
                    if (counter <= 0) {
                        self.gettingReward(mask, button, spriteTable, sprites, numTable, glowTable)
                    }
                }
                for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
                    let recPos = cc.p(v.getPosition())
                    let midPos1 = cc.pMul(cc.pSub(recPos, cc.p(recPos.x * 0.5, recPos.y - 100)), 1.17)
                    let midPos2 = cc.pSub(cc.pMul(cc.pSub(recPos, cc.p(recPos.x * 0.5, recPos.y - 100)), 0.85), midPos1)
                    let recScale = v.getScale()
                    v.setPosition(cc.p(recPos.x * 0.5, recPos.y - 100))
                    v.setScale(0.5)
                    v.runAction(cc.Sequence.create(cc.DelayTime.create((i - 1) * 0.03), cc.ToggleVisibility.create(), cc.EaseSineOut.create(cc.Spawn.create(cc.MoveBy.create(0.25, midPos1), cc.ScaleTo.create(0.25, recScale * 1.17))), cc.EaseSineIn.create(cc.Spawn.create(cc.MoveBy.create(0.33, midPos2), cc.ScaleTo.create(0.33, 0.85))), cc.Spawn.create(cc.MoveTo.create(0.125, recPos), cc.ScaleTo.create(0.125, recScale)), cc.CallFunc.create(function () {
                        let num = v.getChildByName("num")
                        if (num) {
                            num.retain()
                            num.removeFromParent(true)
                            num.setScale(v.getScale() * num.getScale())
                            let size = v.getContentSize()
                            num.setPosition(cc.p(v.getPositionX() + v.getContentSize().width * v.getScaleX() / 2, v.getPositionY()))
                            self.addChild(num, 135)
                            num.release()
                            table.insert(numTable, num)
                        }
                        let glow = self.rewardItemGlowAnim()
                        glow.setPosition(cc.p(v.getPosition()))
                        glow.setScale(0)
                        self.addChild(glow, 115)
                        glow.runAction(cc.ScaleTo.create(0.25, 0.9))
                        table.insert(glowTable, glow)
                    }), cc.DelayTime.create(0.26), cc.RotateTo.create(0.125, 15), cc.RotateTo.create(0.125, -15), cc.RotateTo.create(0.08, 15), cc.RotateTo.create(0.08, -15), cc.RotateTo.create(0.08, 0), cc.CallFunc.create(onAnimFinish)))
                }
                button.setOpacity(0)
                button.setPositionY(button.getPositionY() - 100)
                button.runAction(cc.Sequence.create(cc.Spawn.create(cc.ToggleVisibility.create(), cc.EaseBackOut.create(cc.MoveBy.create(0.33, cc.p(0, 100))), cc.FadeIn.create(0.33)), cc.CallFunc.create(function () {
                    onAnimFinish()
                    PushBounceIdleBubbleAnim.create(button)
                })))
            }
        }), cc.Spawn.create(cc.MoveTo.create(0.166, recPos), cc.ScaleTo.create(0.166, recScale))))
    }
}
MarkRewardPanel.prototype.rewardItemGlowAnim = function () {
    let self = this
    // WARN: maybe multi result
    return CommonAnimation.createStarGlowAnimation()
}
MarkRewardPanel.prototype.gettingReward = function (mask, button, spriteTable, sprites, numTable, glowTable) {
    let self = this
    let proced = false
    let [_, handler] = button.on(UIButtonEvent.Click, function () {
        button.removeEventListener(handler)
        if (proced) {
            return 
        }
        proced = true
        mask.runAction(cc.Sequence.create(cc.FadeOut.create(0.33), cc.CallFunc.create(function () {
            mask.removeFromParent(true)
        })))
        for (let i = 1, v = spriteTable[1]; v; i++, v = spriteTable[i]) {
            let recPos = cc.p(v.getPosition())
            let recScale = v.getScale()
            v.runAction(cc.Sequence.create(cc.Spawn.create(cc.MoveTo.create(0.33, cc.p(recPos.x * 0.6, recPos.y)), cc.FadeOut.create(0.33)), cc.CallFunc.create(function () {
                v.removeFromParent(true)
            })))
        }
        let rewardItems = table()
        for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
            table.insert(rewardItems, table(
                [1, "itemId", v.itemId],
                [1, "num", v.num],
                [1, "icon", v]
            ))
        }
        if ($len(rewardItems) > 0) {
            self.rewardItemAnims(rewardItems, function () {
                if (self.finishCallback) {
                    self.finishCallback()
                }
                if (self.nodeExist) {
                    self.onClose()
                }
            })
        }
        for (let i = 1, v = sprites[1]; v; i++, v = sprites[i]) {
            v.removeFromParent(true)
        }
        for (let i = 1, v = numTable[1]; v; i++, v = numTable[i]) {
            v.removeFromParent(true)
        }
        for (let i = 1, v = glowTable[1]; v; i++, v = glowTable[i]) {
            v.runAction(cc.Sequence.create(cc.FadeOut.create(0.15), cc.CallFunc.create(function () {
                v.removeFromParent(true)
            })))
        }
        let scale = button.getScaleX()
        button.runAction(cc.Sequence.create(cc.Spawn.create(cc.ScaleTo.create(0.2, 0.4 * scale), cc.FadeOut.create(0.2)), cc.CallFunc.create(function () {
            button.removeFromParent(true)
        })))
    })
}
MarkRewardPanel.prototype.rewardItemAnims = function (items, finishCallback) {
    let self = this
    let flyItemOps = table()
    function onAnimFinish() {
        if (finishCallback) {
            finishCallback()
        }
    }
    for (let i = 1, v = items[1]; v; i++, v = items[i]) {
        let parent = v.icon.getParent()
        let pos = parent.convertToWorldSpace(cc.p(v.icon.getPosition()))
        table.insert(flyItemOps, table(
            [1, "itemId", v.itemId],
            [1, "num", v.num],
            [1, "pos", pos]
        ))
    }
    if (type(self.lockTable) === "table") {
        let HomeScene = require("clover/scene/HomeScene")
        let infoBanner = HomeScene.getInstance().infoBanner
        infoBanner.releaseCoin(self.lockTable.coin || 0)
        infoBanner.releaseCash(self.lockTable.cash || 0)
    }
}

MarkRewardPanel.prototype.popup = function () {
    let self = this
    // self.setAnchorPoint(0,0)
    // TODO: why the position is changed?
    let size = cc.director.getWinSize()
    self.setPosition(cc.p(size.width / 2, size.height / 2))
    // BasePanel.prototype.popup.call(self, false, false, function () {})
    PopoutManager.getInstance().add(self, true, false)
    // PopoutManager.getInstance().addWithBgFadeIn(self, false, false)
    self.onEnterAnimFinish()
    // PopoutManager.getInstance().addWithBgFadeIn(self, false, false)
    // self.onEnterAnimStart()
    // var vSize = cc.Director.getInstance().getVisibleSize()
    // PanelBounceAnim.popup(self, 0.3, cc.p(vSize.width / 2, vSize.height / 2), 0, function () {
    //     self.onEnterAnimFinish()
    // })
    return self
}
MarkRewardPanel.prototype.remove = function () {
    let self = this
    cc.log("MarkRewardPanel:remove")
    self.onExitAnimStart()
    PopoutManager.getInstance().remove(self)
}
MarkRewardPanel.prototype.onKeyBackClicked = function () { }
module.exports = MarkRewardPanel
